import SoundManager from './SoundManager';

export default class ButtonSprite extends Phaser.GameObjects.Sprite {

    private text: Phaser.GameObjects.Text | null = null;
    private textRestStyle: object = {};
    private textHoverStyle: object = {};

    constructor(
        scene: Phaser.Scene,
        x: number,
        y: number,
        texture: string,
        frame: string | number,
        callback: () => void
    ) {
        super(scene, x, y, texture, frame);

        this.setInteractive({ useHandCursor: true })
            .setOrigin(0.5)
            .on('pointerover', () => this.enterHoverState())
            .on('pointerout', () => this.enterRestState())
            .on('pointerdown', () => this.enterActiveState())
            .on('pointerup', () => {
                this.enterHoverState();
                callback();
            });

        scene.add.existing(this);
    }

    private enterHoverState() {
        this.setFrame(1);
        if(this.text) {
            this.text.setStyle(this.textHoverStyle);
        }
    }

    private enterRestState() {
        this.setFrame(2);
        if(this.text) {
            this.text.setStyle(this.textRestStyle);
        }
    }

    private enterActiveState() {
        this.setFrame(0);
        SoundManager.getInstance(this.scene).playButtonEffect(); 
    }

    public addText(text: string) {

        this.textRestStyle = { 
            fontFamily: 'equestria',
            fontSize: '50px',
            color: '#32404d',
            padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 10
            },
            stroke: '#ffe182',
            strokeThickness: 6,
            shadow: {
                offsetX: 0,
                offsetY: 0,
                color: '#777',
                blur: 5,
                stroke: true,
                fill: false
            }
        };

        this.textHoverStyle = { 
            color: '#ffffff',
            stroke: '#fea010'
        };

        this.text = this.scene.make.text({
            x: this.x ,
            y: this.y,
            text: text,
            style: this.textRestStyle
        }).setOrigin(0.5);
    }
}